// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1r_IS","left":"InfoRow_left__3UGr3"};